
import Checklistspec from '@/components/Subjects/Checklistspec'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'


export default {
name: 'Choices',
props: {
choice: {},
cuIndex: 0
},
components: {
Checklistspec, Group, Cell
},
data () {
return {
options: [],
anwser: [],
haOptions: ''
}
},
created () {
this.setOptions(this.choice)
},
watch: {
choice: function () {
this.setOptions(this.choice)
}
},
methods: {
getAnswer () {
return this.choice
},
setOptions: function (choice) {
this.options = []
const {options} = choice.choices
const {userAnswer} = choice
this.options = options
this.setShowOk()
if (userAnswer) {
this.anwser.push(userAnswer)
}
},
setShowOk: function () {
for (let i = 0; i < this.options.length; i++) {
this.options[i].showOk = false
}
},
getOption: function (id) {
let option
for (let i = 0; i < this.options.length; i++) {
if (id === this.options[i].id) {
option = this.options[i]
break
}
}
return option
},
toggleOption (value) {
if (value) {
if (value[0]) {
this.setShowOk()
let option = this.getOption(value[0])
if (!option) {
return
}
option.showOk = true
if (option && option.inputMust && option.inputMust === '1' && option.inputType === '2') {
let parentCom = this.$refs[this.choice.id]
this.$nextTick(() => {
if (parentCom.$refs[value[0]][0]) {
parentCom.$refs[value[0]][0].focus()
}
})
}
}
let inputs = []
for (let i = 0; i < this.options.length; i++) {
if (value[0] === this.options[i].id && this.options[i].inputVal) {
let temp = {}
temp.optionId = value[0]
temp.optionInput = this.options[i].inputVal
inputs.push(temp)
break
}
}
this.choice.userInput = inputs
this.choice.userAnswer = value[0]
this.$emit('on-autoshow', this.choice)
/*     console.log(this.choice,5555)*/

if (value.length > 0 && this.haOptions.length === 0) {





}
}else{
this.setShowOk();
}
}
}
}



// WEBPACK FOOTER //
// ./src/components/Subjects/Choices/index.vue